// src/lib/studentId.js
// ──────────────────────────────────────────────────────────────────────────
// Students can log in with a Student ID or a real email. Supabase always logs
// in by email, so a Student ID is mapped to an internal email address using a
// fixed domain. Students never need a real inbox for that address.
//
//   MTI/2026/001  →  mti-2026-001@students.mti.local
//
// Keep ID_DOMAIN consistent everywhere (it's only ever internal).
// ──────────────────────────────────────────────────────────────────────────

export const ID_DOMAIN = 'students.mti.local';

export const looksLikeEmail = (v) => /\S+@\S+\.\S+/.test(v);

export function idToEmail(studentId) {
  const slug = String(studentId).trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  return `${slug}@${ID_DOMAIN}`;
}

// Turn whatever the user typed (ID or email) into the email Supabase needs.
export function loginIdentifierToEmail(input) {
  const v = String(input).trim();
  return looksLikeEmail(v) ? v.toLowerCase() : idToEmail(v);
}
